import Button from "components/ui/Button"

function Announcement({ id, text, ctaText, ctaLink, onClick }) {
  if (text) {
    return (
      <div className="relative w-full bg-black-squeeze px-4 py-2 text-center text-base font-bold">
        {text}
        <Button
          className="mx-2"
          href={ctaLink}
          trackClick={`Announcement Bar Link Clicked ${id || ""}`}
          color="green"
          nowrap
          link
        >
          {ctaText}
        </Button>
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <Button
            className="mx-3 px-1"
            onClick={onClick}
            trackClick={`Announcement Bar Closed ${id || ""}`}
            link
          >
            ✕
          </Button>
        </div>
      </div>
    )
  }
  return null
}

export default Announcement
